import React from 'react';

const Divider: React.FC = () => (
  <div className="w-full border-t border-solid border-[#f0f0f0]" />
);

Divider.displayName = 'Divider';

export default Divider;
